import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeBossQuery from "@saleor/hooks/makeBossQuery";
import gql from "graphql-tag";

import {
  BrandVerticalDownload,
  BrandVerticalDownloadVariables
} from "./types/BrandVerticalDownload";
import {
  BrandVerticalReport,
  BrandVerticalReportVariables
} from "./types/BrandVerticalReport";

export const brandVerticalReportList = gql`
  ${pageInfoFragment}
  query BrandVerticalReport(
    $before: String
    $after: String
    $first: Int
    $last: Int
    $filter: BrandDetailsFilterInput!
  ) {
    brandDetails(
      before: $before
      after: $after
      first: $first
      last: $last
      filter: $filter
    ) {
      totalCount
      pageInfo {
        ...PageInfoFragment
      }
      edges {
        cursor
        node {
          id
          brand_name
          vertical
        }
      }
    }
  }
`;

export const useBrandVerticalsQuery = makeBossQuery<
  BrandVerticalReport,
  BrandVerticalReportVariables
>(brandVerticalReportList);

export const brandVerticalDownload = gql`
  ${pageInfoFragment}
  query BrandVerticalDownload(
    $before: String
    $after: String
    $first: Int
    $last: Int
    $filter: BrandDetailsFilterInput!
  ) {
    brandDetails(
      before: $before
      after: $after
      first: $first
      last: $last
      filter: $filter
    ) {
      totalCount
      pageInfo {
        ...PageInfoFragment
      }
      edges {
        cursor
        node {
          brand_name
          vertical
          brand_status
        }
      }
    }
  }
`;

export const useBrandVerticalsDownload = makeBossQuery<
  BrandVerticalDownload,
  BrandVerticalDownloadVariables
>(brandVerticalDownload);
